export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref10011.dae84d1d.jpg";